module.exports = __webpack_public_path__ + "static/images/info.db550c22f7a9231ad23525cd513d5329.svg";